module.exports = __webpack_public_path__ + "assets/img/1icon.2d7c7b9b.png";